import CenterIdentity from "centeridentity";

import { API_KEY, API_SERVER } from "./config";
import { makeApiUrl, makeUrl } from "./makeUrl";
import axios from "axios";

export async function auth(
  selectedLocations: { lat: number; lng: number }[],
  email: string,
  mode: string
) {
  const ci = new CenterIdentity({
    strength: "low",
    api_key: API_KEY,
    precision: 4,
    url_prefix: API_SERVER,
  });
  if (mode === 'auth') {
    return await ci.auth(selectedLocations, email)
  } else if (mode === 'register') {
    return await ci.register(selectedLocations, email)
  }
}
